/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  display: block;
  block-size: 100%;
}

.svg {
  fill: currentColor;
  stroke: transparent;
  margin: 0px;
  display: block;
  block-size: 100%;
  inline-size: 100%;
  padding: 0px;
}
.svg .graph-path--highlight {
  fill: var(--calcite-color-brand);
  opacity: 0.5;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}